import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRedirectUrl } from '../js/api-service';
import { InfoContext } from './context';
import { getSmsCode, checkSmsCode } from '../js/api-service';


export default function DefaultHome() {

    const { updateFail, smsConfirm, setSmsConfirm, updateSessionStorage } = useContext(InfoContext)
    const [email, setEmail] = useState("");
    const [claimNumber, setClaimNumber] = useState("");
    const [smsCode, setSmsCode] = useState("");
    const [smsResult, setSmsResult] = useState();
    const [failMessage, setFailMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleClaimSubmit = async (event) => {
        event.preventDefault();
        if (claimNumber === "" || email === "") return;
        setLoading(true);
        updateSessionStorage();
        try {
            const result = await getSmsCode(claimNumber, email);
            if (!result) {
                setFailMessage(true);
            } else {
                setSmsConfirm(true);
                setSmsResult(result);
                setFailMessage(false);
            }
        } catch {
            setFailMessage(true);
        }
        setLoading(false);
    }

    const handleSmsCheck = async (event) => {

        event.preventDefault();
        if (smsCode === "") return;
        setLoading(true);
        try {
            const result = await checkSmsCode(smsCode, smsResult?.currentTime);
            if (!result) {
                setFailMessage(true);
            } else {
                setSmsConfirm(false);
                setFailMessage(false);
                navigate(`/?Session=${result}`, { state: { session: result } });
            }
        } catch {
            setFailMessage(true);
        }
        setLoading(false);
    }

    return (
        <>
            {loading && <div className="loading" aria-label="Vänligen vänta."></div>}
            {!loading && <>
                <h2 className="large-header align-center portal-title">Tervetuloa Crawfordin portaaliin</h2>
                <div className="home-container smslogin">
                    {!smsConfirm ?
                        <>
                            <p>Anna lähettämämme sähköpostin otsikkokentässä oleva tapausnumero ja sähköpostiosoitteesi alla ja paina lähetä. Saat sen jälkeen tekstiviestillä koodin, jolla kirjaudut portaaliimme</p>
                            <form name='claimForm' onSubmit={(event) => { handleClaimSubmit(event) }}>
                                <input type='text' name='claimNumber' placeholder='Tapausnumero' aria-label='Tapausnumero' required onChange={(event) => setClaimNumber(event.target.value.trim())} />
                                <input type='email' name='email' placeholder='Sähköposti' aria-label='Sähköposti' required onChange={(event) => setEmail(event.target.value.trim())} />
                                <button type='submit' className='submit-button' disabled={claimNumber === "" || email === ""} >Lähetä</button>
                                {failMessage && <p className='error-message'>Antamallasi tapausnumerolla ja sähköpostiosoitteella ei löytynyt tapausta!</p>}
                            </form>
                        </>
                        :
                        <>
                            <p>Syötä koodi, jonka lähetimme osoitteeseen {smsResult?.mobile}</p>
                            <form name='smsForm' onSubmit={(event) => { handleSmsCheck(event) }}>
                                <input type='text' autoFocus name='smsCode' placeholder='Tekstiviestikoodi' aria-label='Tekstiviestikoodi' pattern="[0-9]{6}$" required onChange={(event) => setSmsCode(event.target.value.trim())} inputMode='numeric' />
                                <button type='submit' className='submit-button' disabled={smsCode === "" || smsCode.length !== 6} >Lähetä</button>
                                {failMessage && <p className='error-message'>Tapahtui virhe! Yritä uudelleen tai ota meihin yhteyttä.</p>}
                            </form>
                        </>
                    }
                </div>
            </>
            }
        </>
    )
}
